module.exports = __webpack_public_path__ + "static/media/Retrusion of the anterior teeth12.56d1a064.png";